<!-- eslint-disable vuejs-accessibility/heading-has-content -->
<template>
  <div class="store-locator-map critical-component-clear">
    <div class="store-locator-map__interface-wrapper">
      <uberall-search-interface
        :visible-stores="visibleStores"
        @locations-data="setDataOnMap"
        @location-id="showListSelectedStoreOnMap"
        @address-search="searchUserEnteredAddress"
        @reset-view="resetViewPort"
        @user-location="zoomIntoUserLocation"
      />

      <div
        v-if="!isMobile"
        id="uberall-locator-map"
        class="store-locator-map__uberall-locator-map"
      />
    </div>

    <uberall-locator-info-box />
  </div>
</template>

<script>

/**
 * Vue: Store locator map (store-locator-map)
 * -----------------------------------------------------------------------------
 * Map Interface for store locator.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */

import { mapState } from 'vuex'
import MapInterface from './google-map-api'
import UberallLocatorInfoBox from './uberall-locator-info-box/uberall-locator-info-box'
import UberallSearchInterface from './uberall-search-interface/uberall-search-interface'

export default {
  name: 'StoreLocatorMap',

  components: {
    UberallLocatorInfoBox,
    UberallSearchInterface,
  },

  data() {
    return {
      visibleStores: null,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  mounted() {
    this.startMap()
  },

  methods: {

    /**
     * Initialize map interface
     */
    startMap() {
      MapInterface.isMobile = this.isMobile
      MapInterface.init()
      MapInterface.visibleStoresCallback = (storeIds) => {
        this.visibleStores = storeIds
      }
    },

    /**
     * Set stores on map
     * @param locations
     */
    setDataOnMap(locations) {
      MapInterface.setLocations(locations)

      if (MapInterface.markers.length > 0) {
        MapInterface.updateMarkers()
        MapInterface.updateClusterer()

        return
      }

      if (MapInterface.mapTilesLoaded) {
        MapInterface.setAllMarkersOnMap()
      }
    },

    /**
     * Emits id of selected store from search list
     * @param id
     */
    showListSelectedStoreOnMap(id) {
      MapInterface.showSelectedStore(id)
    },

    /**
     * Search user entered address
     */
    searchUserEnteredAddress(address) {
      MapInterface.handleGeocode({ address })
    },

    /**
     * Set Map on initial position
     */
    resetViewPort() {
      MapInterface.removeInfoBox()
      MapInterface.resetViewPort()
    },

    /**
     * Zooming into user location when data is available
     *
     * @param {Object} location
     */
    zoomIntoUserLocation(location) {
      MapInterface.zoomIntoUserLocation(location)
    },

  },
}
</script>

<style lang="scss">
@import './store-locator-map';
</style>
